module.exports = "<div class=\"row w-100 m-auto\" style=\"height: 100vh;\">\r\n    <iframe style=\"width: 100%; height: auto; padding: 1.8px\" src=\"http://privacy-policy.infoviewsims.com\" frameborder=\"0\"></iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/session/coming-soon/coming-soon-component.html
// module id = ../../../../../src/app/session/coming-soon/coming-soon-component.html
// module chunks = main